import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { ControlContainer, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { InputBase } from '@ui/components/form9/base/input-base';
import { inputSensorids9Validator } from '@ui/components/form9/controls/input/input-sensorids9/input-sensorids9.validators';

@Component({
    selector: 'aa-input-sensorids9',
    templateUrl: './input-sensorids9.component.html',
    styleUrls: [
        '../input9.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((): typeof InputSensorids9Component => InputSensorids9Component),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef((): typeof InputSensorids9Component => InputSensorids9Component),
            multi: true,
        }
    ],
    standalone: false
})
export class InputSensorids9Component extends InputBase<string> implements OnInit
{
    private static identifier: number = 0;

    constructor (
        injector: Injector,
        controlContainer: ControlContainer
    )
    {
        super(injector, controlContainer);

        this.fieldId = `idInputText9-${InputSensorids9Component.identifier++}`;
    }

    ngOnInit (): void
    {
        this.initControl([inputSensorids9Validator(this.customMsg)]);
    }
}
